// extracted by mini-css-extract-plugin
export default {"container":"Features_container__4HrJ9","row":"Features_row__cigns","cell":"Features_cell__EtliG","active":"Features_active__+pnb1","inactive":"Features_inactive__Kj4r4"};